<form #supplierForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="supplier">
    <div>
        <button class="btn btn-success" type="submit">{{'supplier-form.label.save' | translate}}</button>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 margin-devider">
            <div class="gradient-effect ">
                <div class="form-group row">
                    <label for="supplier-code" class="col-sm-2 col-form-label">{{'supplier-form.label.code' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.code" name="supplier.code" type="text" class="form-control" id="supplier-code" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-desc" class="col-sm-2 col-form-label">{{'supplier-form.label.designation' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.desc" name="supplier.desc" type="text" class="form-control" id="supplier-desc" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-name1" class="col-sm-2 col-form-label">{{'supplier-form.label.name1' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.name1" name="person.name1" type="text" class="form-control" id="supplier-person-name1" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-name2" class="col-sm-2 col-form-label">{{'supplier-form.label.name2' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.name2" name="person.name2" type="text" class="form-control" id="supplier-person-name2" placeholder="">
                    </div>
                </div>


                <div class="form-group row">
                    <label for="supplier-person-name3" class="col-sm-2 col-form-label">{{'supplier-form.label.name3' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.name3" name="person.name3" type="text" class="form-control" id="supplier-person-name3" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-address1" class="col-sm-2 col-form-label">{{'supplier-form.label.adress1' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.address1" name="person.address1" type="text" class="form-control" id="supplier-person-address1" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-address2" class="col-sm-2 col-form-label">{{'supplier-form.label.adress2' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.address2" name="person.address2" type="text" class="form-control" id="supplier-person-address2" placeholder="">
                    </div>
                </div>
            </div>
        </div>
        <!-- end of left side -->
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 margin-devider">
            <div class="gradient-effect ">
                <div class="form-group row">
                    <label for="supplier-person-country" class="col-sm-2 col-form-label">{{'supplier-form.label.country' | translate}}:</label>
                    <div class="col-sm-10">
                        <select [(ngModel)]="supplier.person.country" name="person.country" class="form-control" id="supplier-person-country">
        <option value="">-</option>
        <option *ngFor="let country of countries" value="{{country.code}}">{{country.code}} ({{country.name}})</option>
      </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="supplier-person-state" class="col-sm-2 col-form-label">{{'supplier-form.label.state' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.state" name="person.state" type="text" class="form-control" id="supplier-person-state" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-zip" class="col-sm-2 col-form-label">{{'supplier-form.label.zip' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.zip" name="person.zip" type="text" class="form-control" id="supplier-person-zip" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-city" class="col-sm-2 col-form-label">{{'supplier-form.label.city' | translate}}:</label>
                    <div class="col-sm-10">
                        <input [(ngModel)]="supplier.person.city" name="person.city" type="text" class="form-control" id="supplier-person-city" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-person-language" class="col-sm-2 col-form-label">{{'supplier-form.label.language' | translate}}:</label>
                    <div class="col-sm-10">
                        <select [(ngModel)]="supplier.person.language" name="person.language" type="text" class="form-control" id="supplier-person-language">
        <option value="">-</option>
        <option *ngFor="let lang of languages" value="{{lang.code}}">{{lang.code}} ({{lang.name}})</option>
      </select>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-active" class="col-sm-2 col-form-label">{{'supplier-form.label.active' | translate}}:</label>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-1">
                        <input [(ngModel)]="supplier.active" name="supplier.active" type="checkbox" class="form-control" id="supplier-active" placeholder="">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="supplier-own" class="col-sm-2 col-form-label">{{'supplier-form.label.own' | translate}}:</label>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-1">
                        <input [(ngModel)]="supplier.own" name="supplier.own" type="checkbox" class="form-control" id="supplier-own" placeholder="">
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>


// WEBPACK FOOTER //
// ./src/app/product/supplier-form/supplier-form.component.html